
import React, { Fragment } from 'react'
import {AppAction,AppButton,AppRow} from 'qcc'
import { Row, Icon } from 'antd';

export const AppEventDemo = () =>{
    return (<div className='app-demo-content'>
            <h1>使用说明</h1>    
            <div>
                1、操作界面的事件方法，需要用户界面交互时使用。<br/>
                2、引用：import {`{AppAction}`} from 'qcc'<br/>
                3、demo位置：src/demo/components/AppAction.tsx
            </div>

            <h1>DEMO</h1>
            <div className='app-demo-content-demo'>
                <Row  className="demo-title"><label> 打开模态窗口</label></Row>
                <Row style={{padding:20}}>
               
                    <AppRow>
                        <AppButton type='primary'
                                   label='打开' 
                                   action={()=>{AppAction.openDialog(<div>这是内容</div>,
                                    {title:'测试'})}}  
                        />
                        <AppButton label='关闭' action={()=>{AppAction.closeDialog()}}/>
                    </AppRow>
                    <h3>使用说明</h3>    
                <div>
                    1、AppAction.openDialog: (component?: React.ReactElement, props?: DialogProps)。<br/>
                    2、component:为打开的页面组件<br/>
                    3、props为页面显示参数，控制页面大小位置，标题<br/>
                </div>
                </Row>


                 <Row  className="demo-title"><label> 打开新页面</label></Row>
                <Row style={{padding:20}}>
                    <AppRow>
                        <AppButton type='primary'
                                   label='打开' 
                                   action={()=>{AppAction.open('/demo')}}  
                        />
                    </AppRow>
                    <h3>使用说明</h3>    
                <div>
                    1、AppAction.open: (url: string)<br/>
                    2、url:为打开的页面地址<br/>
                </div>
                </Row>


                <Row  className="demo-title"><label> 重定向</label></Row>
                <Row style={{padding:20}}>
                    <AppRow>
                        <AppButton type='primary'
                                   label='跳转' 
                                   action={()=>{AppAction.redirect('/login')}}  
                        />
                    </AppRow>
                    <h3>使用说明</h3>    
                <div>
                    1、AppAction.redirect: (url: string)<br/>
                    2、必须在登录后才能使用<br/>
                    2、url:为打开的页面地址<br/>
                </div>
                </Row>
               
                
            </div>
            
    </div>)
}


// WEBPACK FOOTER //
// ./src/demo/components/AppEventDemo.tsx